import './styles.css';
import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useTable, usePagination, useGlobalFilter, useSortBy } from 'react-table';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import { Grid, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Button, Select, MenuItem, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputLabel, Alert } from '@mui/material';
import { Box } from '@mui/system';
import {
  AppTasks,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppWidgetSummary,
} from '../sections/@dashboard/app';

const fetchData = async (url) => {
  const response = await fetch(url);
  return response.json();
};



export default function DashboardAppPage() {
  const theme = useTheme();
  const tipo = localStorage.getItem('Tipo');
  const transportista = localStorage.getItem('Transportista');
  const [mandante, setMandante] = useState(localStorage.getItem('Mandante')); 
  const [plantas, setPlantas] = useState([]);
  const [selectedPlanta, setSelectedPlanta] = useState('');
  const [selectedMes, setSelectedMes] = useState('');
  const [selectedAño, setSelectedAño] = useState('');
  const [estadoBrecha, setEstadoBrecha] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [consultado, setConsultado] = useState(false);
  const [inspeccionesMes, setInspeccionesMes] = useState(0);
  const [desviacionesMes, setDesviacionesMes] = useState(0);
  const [aprobadosMes, setAprobadosMes] = useState(0);
  const [cerradosMes, setCerradosMes] = useState(0);
  const [jsonTransportistas, setJsonTransportistas] = useState([]);
  const [jsonComparaciones, setJsonComparaciones] = useState([]);
  const [jsonClasificaciones, setJsonClasificaciones] = useState([]);
  const [jsonDesviaciones, setJsonDesviaciones] = useState([]);
  const [jsonDesviacionesRecurrentes, setJsonDesviacionesRecurrentes] = useState([]);
  const [chartLabelsTransportistas, setChartLabelsTransportistas] = useState([]);
  const [chartDataTransportistas, setChartDataTransportistas] = useState([]);
  const [chartLabelsComparacion, setChartLabelsComparacion] = useState([]);
  const [chartDataComparacion, setChartDataComparacion] = useState([]);
  const [chartDataClasificaciones, setChartDataClasificaciones] = useState([]);
  const [chartColorsClasificaciones, setChartColorsClasificaciones] = useState([]);
  const [chartLabelsRecurrentes, setChartLabelsRecurrentes] = useState([]);
  const [chartDataRecurrentes, setChartDataRecurrentes] = useState([]);
  const [isLoading, setIsLoading] = useState(false); 
  const [updateInfo, setUpdateInfo] = useState(true);
  const [file, setFile] = useState(null); 
  const [rowsDesviaciones, setRowsDesviaciones] = useState([]);
  const [columnsDesviaciones, setColumnsDesviaciones] = useState([]);
  
  useEffect(() => {
    fetchData(`https://asetran.cl/api/enex/listado_planta.php?mandante=${mandante}&_=${new Date().getTime()}`)
      .then(data => setPlantas(data))
      .catch(error => console.error(error));

    setUpdateInfo(false)
  }, [updateInfo]);

  useEffect(() => {
    const transportistas = jsonTransportistas.map(item => item.Transportista);
    const cantidades = jsonTransportistas.map(item => item.Cantidad);

    setChartLabelsTransportistas(transportistas);
    setChartDataTransportistas([{
      name: 'N° Inspecciones',
      type: 'column',
      fill: 'solid',
      data: cantidades,
    }]);
  }, [jsonTransportistas]);

  useEffect(() => {
    const periodo = jsonComparaciones.map(item => item.Periodo);
    const cantidades = jsonComparaciones.map(item => item.Total);

    setChartLabelsComparacion(periodo);
    setChartDataComparacion([{
      name: 'N° Inspecciones',
      type: 'column',
      fill: 'solid',
      data: cantidades,
    }]);
  }, [jsonComparaciones]);

  useEffect(() => {
    setRowsDesviaciones(jsonDesviacionesRecurrentes.map((row, index) => ({
      id: index,
      Item: row.Item,
      Clasificacion: row.Clasificacion,
      Cantidad: row.Cantidad,
    })));

    setColumnsDesviaciones([
      { field: 'Item', headerName: 'Item', width: 700 },
      { field: 'Clasificacion', headerName: 'Clasificacion', width: 130 },
      { field: 'Cantidad', headerName: 'Cantidad', width: 80 },
    ]);
  }, [jsonDesviacionesRecurrentes]);

  useEffect(() => {
    const transportistas = jsonTransportistas.map(item => item.Transportista);
    const cantidades = jsonTransportistas.map(item => item.Cantidad);

    setChartLabelsTransportistas(transportistas);
    setChartDataTransportistas([{
      name: 'N° Inspecciones',
      type: 'column',
      fill: 'solid',
      data: cantidades,
    }]);
  }, [updateInfo]);

  useEffect(() => {
    const clasificacion = jsonClasificaciones.map(item => item.Clasificacion);
    const cantidades = jsonClasificaciones.map(item => item.Cantidad * 1);

    const clasificacionColors = {
      'Leve': theme.palette.primary.main,
      'Menos Grave': theme.palette.warning.main,
      'Grave': theme.palette.error.main
    }

    const chartData = clasificacion.map((label, index) => ({
      label,
      value: cantidades[index]
    }));

    const chartColors = clasificacion.map(label => clasificacionColors[label]);

    setChartDataClasificaciones(chartData)
    setChartColorsClasificaciones(chartColors);
  }, [jsonClasificaciones]);

  const currentYear = new Date().getFullYear();
  const years = [currentYear, currentYear - 1];
  const months = [...Array(12).keys()].map(i => ({
    value: i + 1,
    label: new Date(0, i + 1, 0).toLocaleString('es-ES', { month: 'long' })
  }));
  
  const data = useMemo(() => jsonDesviaciones, [jsonDesviaciones]);

  const columns = useMemo(() => [
    { Header: 'Id', accessor: 'Id', width: '10%' },
    { Header: 'Patente', accessor: 'Patente', width: '12%' },
    { Header: 'FechaHora', accessor: 'FechaHora', width: '10%'  },
    { Header: 'Desviacion', accessor: 'Desviacion', width: '50%' }, 
    { Header: 'Clasificacion', accessor: 'Clasificacion', width: '12%' }, 
    { Header: 'Observacion', accessor: 'Observacion', width: '40%' }, 
    { Header: 'Acciones', Cell: ({ row }) => <Button variant="contained" color="warning" onClick={() => handleOpenModal(row)} sx={{ marginLeft: '15px' }}>Actualizar</Button>}
  ], []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    { columns, data },
    useGlobalFilter, // Usar filtro global
    useSortBy,       // Usar ordenamiento
    usePagination
  );

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const handleOpenModal = (row) => {
    setSelectedRow(row.original.Id); 
    setModalIsOpen(true);
  };
  
  const handleCloseModal = () => {
    setModalIsOpen(false);
    setEstadoBrecha(''); // Añadir esta línea
    setObservaciones(''); // Añadir esta línea
    setFile(null); // Añadir esta línea
  };

  const actualizarDesviacion = async () => {
    const respuesta = estadoBrecha === 1 ? 'Si' : 'No'; 
    
    const url = 'https://asetran.cl/api/enex/actualizar_desviacion.php';

    // Crear un objeto FormData
    const formData = new FormData();
    formData.append('id', selectedRow);
    formData.append('observacion', observaciones);
    formData.append('cerrado', estadoBrecha);
    formData.append('respuesta', respuesta);

    // Agregar el archivo al FormData, si hay uno seleccionado
    if (file) {
        formData.append('archivo', file);
    }

    // Enviar solicitud POST
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const data = await response.json();
        // Manejar la respuesta (por ejemplo, mostrar un mensaje, actualizar el estado, etc.)
    } catch (error) {
        // Manejar error
        console.error("Hubo un error al enviar la solicitud:", error);
    }
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    actualizarDesviacion()
    setTimeout(() => {
      setEstadoBrecha(''); // Añadir esta línea
      setObservaciones(''); // Añadir esta línea
      setModalIsOpen(false);
      handleConsultar();
      setIsLoading(true);
    }, "1000");
  };

  const handleMandante= async (id) => {
    setMandante(id)
    setUpdateInfo(true)
  };

  const handleConsultar = async () => {
    let url
    let url2
    let url3
    let url4
    let url5
    let url6
    let url7
    let url8
    let url9
    if(transportista > 1){
      url = `https://asetran.cl/api/enex/transportista/total_inspecciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url2 = `https://asetran.cl/api/enex/transportista/total_desviaciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url3 = `https://asetran.cl/api/enex/transportista/total_aprobados.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url4 = `https://asetran.cl/api/enex/transportista/total_brechas_cerradas.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url5 = `https://asetran.cl/api/enex/transportista/total_inspecciones_transportistas.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url6 = `https://asetran.cl/api/enex/transportista/clasificacion_desviaciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url7 = `https://asetran.cl/api/enex/transportista/listado_desviaciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url8 = `https://asetran.cl/api/enex/transportista/listado_desviaciones_recurrentes.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
      url9 = `https://asetran.cl/api/enex/transportista/comparacion_mes.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&transportista=${transportista}&_=${new Date().getTime()}`;
    } else {
      url = `https://asetran.cl/api/enex/total_inspecciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url2 = `https://asetran.cl/api/enex/total_desviaciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url3 = `https://asetran.cl/api/enex/total_aprobados.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url4 = `https://asetran.cl/api/enex/total_brechas_cerradas.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url5 = `https://asetran.cl/api/enex/total_inspecciones_transportistas.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url6 = `https://asetran.cl/api/enex/clasificacion_desviaciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url7 = `https://asetran.cl/api/enex/listado_desviaciones.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url8 = `https://asetran.cl/api/enex/listado_desviaciones_recurrentes.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
      url9 = `https://asetran.cl/api/enex/comparacion_mes.php?planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
    }
    setConsultado(false);
    setIsLoading(true);
    const response = await fetch(url);
    const data = await response.json();
    
    setInspeccionesMes(data[0].total); // suponiendo que tienes un estado para este valor

    const response2 = await fetch(url2);
    const data2 = await response2.json();
    
    setDesviacionesMes(data2[0].total); // suponiendo que tienes un estado para este valor

    const response3 = await fetch(url3);
    const data3 = await response3.json();
    
    setAprobadosMes(data3[0].total); // suponiendo que tienes un estado para este valor

    const response4 = await fetch(url4);
    const data4 = await response4.json();
    
    setCerradosMes(data4[0].total); // suponiendo que tienes un estado para este valor

    const response5 = await fetch(url5);
    const data5 = await response5.json();
    
    setJsonTransportistas(data5); // suponiendo que tienes un estado para este valor 

    const response6 = await fetch(url6);
    const data6 = await response6.json();
    
    setJsonClasificaciones(data6); // suponiendo que tienes un estado para este valor 

    const response7 = await fetch(url7);
    const data7 = await response7.json();
    
    setJsonDesviaciones(data7); // suponiendo que tienes un estado para este valor 

    const response8 = await fetch(url8);
    const data8 = await response8.json();
    
    setJsonDesviacionesRecurrentes(data8); // suponiendo que tienes un estado para este valor 

    const response9 = await fetch(url9);
    const data9 = await response9.json();
    
    setJsonComparaciones(data9);

    setConsultado(true);
    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <title> ENEX Check - ASETRAN</title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          DASHBOARD 
        </Typography>

        {tipo === 'Administrador' && (
          <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
            <InputLabel sx={{ marginTop: '-8px' }}>Mandante</InputLabel>
            <Select
              value={mandante}
              onChange={e => handleMandante(e.target.value)}
            >
                <MenuItem key={13} value={13}>ENEX</MenuItem>
                <MenuItem key={20} value={20}>MEJILLONES</MenuItem>
                <MenuItem key={22} value={22}>LA GREDA</MenuItem>
            </Select>
          </FormControl> 
        )}

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Planta</InputLabel>
          <Select
            value={selectedPlanta}
            onChange={e => setSelectedPlanta(e.target.value)}
          >
            {plantas.map(item => 
              <MenuItem key={item.id} value={item.id}>{item.planta}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Mes</InputLabel>
          <Select
            value={selectedMes}
            onChange={e => setSelectedMes(e.target.value)}
          >
            {months.map((month, index) => 
              <MenuItem key={index} value={month.value}>{month.label}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Año</InputLabel>
          <Select
            value={selectedAño}
            onChange={e => setSelectedAño(e.target.value)}
          >
            {years.map(year => 
              <MenuItem key={year} value={year}>{year}</MenuItem>
            )}
          </Select>
        </FormControl>

        <Button variant="contained" color="primary" onClick={handleConsultar} sx={{ marginLeft: '15px' }}>
          {isLoading ? 'Cargando...' : 'Consultar'}
        </Button>
        
        {consultado && jsonDesviaciones.length > 0 &&(
          <Grid container spacing={3} style={{marginTop: '1%'}}>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary title="Total de Inspecciones Mes" total={inspeccionesMes}  />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary title="Equipos Aprobados" total={aprobadosMes} color="info"  />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary title="Total Desviaciones" total={desviacionesMes} color="error"  />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary title="Total Brechas Cerradas" total={cerradosMes} color="warning"  />
            </Grid>

            <Grid item xs={12} md={6} lg={8}>
              <AppWebsiteVisits
                title="Equipos Revisados"
                subheader="Cantidad de equipos revisados por transportista"
                chartLabels={chartLabelsTransportistas}
                chartData={chartDataTransportistas}
              />
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <AppWebsiteVisits
                title="Comparación Mes Actual vs. Anterior"
                subheader="Cantidad de equipos revisados del mes anterior a la fecha"
                chartLabels={chartLabelsComparacion}
                chartData={chartDataComparacion}
              />
            </Grid>

            <Grid item xs={12} md={6} lg={8}>
              <div style={{ height: 465, width: '100%', backgroundColor: 'white'}}>
                <Typography variant="h6" sx={{ mb: 1 }} style={{marginTop: '2%'}}>
                  Desviaciones recurrentes
                </Typography>
                <DataGrid
                  rows={rowsDesviaciones}
                  columns={columnsDesviaciones}
                  pageSize={5}
                  disableColumnResize={false}
                  getRowClassName={(params) => {
                    if(params.row.Clasificacion === 'Leve') {
                      return 'leve';
                    }
                    if(params.row.Clasificacion === 'Menos Grave') {
                      return 'menos-grave';
                    }
                    if(params.row.Clasificacion === 'Grave') {
                      return 'grave';
                    }
                    return ''; // valor por defecto
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>              
              <AppCurrentVisits
                title="Clasificacion Desviaciones"
                chartData={chartDataClasificaciones} 
                chartColors={chartColorsClasificaciones}
              />
            </Grid>

            <Typography variant="h6" sx={{ mb: 1 }} style={{marginTop: '2%'}}>
              DESVIACIONES REGISTRADAS
            </Typography>
            
            <Grid item xs={12} md={12} lg={12}>
              <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginBottom: '10px',
                  }}
                >
                  <TextField
                    value={globalFilter || ''}
                    onChange={e => setGlobalFilter(e.target.value)}
                    placeholder="Buscar..."
                    variant="outlined"
                    size="small"
                  />
                </div>
                <TableContainer component={Paper} sx={{ width: '100%', overflow: 'auto' }}>
                  <Table {...getTableProps()} sx={{ minWidth: 750 }}>
                    <TableHead>
                      {headerGroups.map(headerGroup => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map(column => (
                            <TableCell {...column.getHeaderProps(column.getSortByToggleProps())}>
                              {column.render('Header')}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? ' 🔽'
                                    : ' 🔼'
                                  : ''}
                              </span>
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableHead>
                    <TableBody {...getTableBodyProps()}>
                      {page.map(row => {
                        prepareRow(row);
                        return (
                          <TableRow {...row.getRowProps()}>
                            {row.cells.map(cell => (
                              <TableCell {...cell.getCellProps()} style={{ width: cell.column.width }}>{cell.render('Cell')}</TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>

                <FormControl>
                  <Typography component="div">
                    Página{' '}
                    <strong>
                      {pageIndex + 1} de {pageOptions.length}
                    </strong>{' '}
                  </Typography>


                </FormControl>

                <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                  {'<<'}
                </Button>
                <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
                  {'<'}
                </Button>
                <Button onClick={() => nextPage()} disabled={!canNextPage}>
                  {'>'}
                </Button>
                <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                  {'>>'}
                </Button>
              </Box>

              <Dialog
                open={modalIsOpen}
                onClose={handleCloseModal}
              >
                <DialogTitle>Cierre de brecha</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth>
                    <InputLabel style={{marginTop: 10}}>Estado de desviación</InputLabel>
                    <Select
                      defaultValue=""
                      value={estadoBrecha}
                      onChange={e => setEstadoBrecha(e.target.value)}
                    >
                      <MenuItem value="1">Cerrar Brecha</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    margin="dense"
                    label="Observaciones"
                    fullWidth
                    multiline
                    rows={4}
                    value={observaciones}
                    onChange={e => setObservaciones(e.target.value)}
                  />
                  <input
                      type="file"
                      onChange={e => setFile(e.target.files[0])}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseModal}>Cerrar</Button>
                  <Button onClick={handleUpdate}>{isLoading ? 'Cargando...' : 'Actualizar'}</Button>
                </DialogActions>
              </Dialog>

            </Grid>

          </Grid>
        )}
      </Container>
    </>
  );
}
